import { Box, Grid, styled, Typography } from "@mui/material";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { primary } from "../../constants/theme";

const CustomerBrandVehicleVariant = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  //alignItems: "center",

  flexDirection: "column",
  paddingLeft: "8%",
  paddingRight: "8%",
  marginTop: "48px",

  justifyContent: "center",

  ".vehicles-grid-container": {
    padding: "60px",
    backgroundColor: primary?.lightGrey,
  },
  ".promiseHeader": {
    fontSize: "24px",
    fontWeight: "700",
    letterSpacing: "0em",
    textAlign: "left",
    paddingBottom: "20px",
  },

  ".sub-text": {
    padding: "0px 0px 10px 0px ",
    fontWeight: 700,
    fontSize: "20px",
  },

  ".price-list": {
    padding: "20px",
  },
  ".Vehicle-container": {
    display: "flex",
    flexDirection: "row"
  },

  [theme.breakpoints.down("md")]: {
    paddingLeft: "2%",
    paddingRight: "2%",
    marginTop: "0px",
    justifyContent: "center",

    ".vehicles-grid-container": {
      padding: "20px",
    },
    ".promiseHeader": {
      fontSize: "24px",
      paddingBottom: "20px",
    },

    ".sub-text": {
      fontSize: "16px",
    },
  },
  [theme.breakpoints.down("sm")]: {
    paddingLeft: "2%",
    paddingRight: "2%",
    marginTop: "0px",

    ".promiseHeader": {
      fontSize: "24px",
      paddingBottom: "20px",
    },

    ".sub-text": {
      fontSize: "16px",
    },

    ".vehicles-grid-container": {
      padding: "20px",
    },
    ".Vehicle-container": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "initial",
    },
  },
}));

const BrandVehicleVariant = ({ brandVariantData }) => {
  return (
    <CustomerBrandVehicleVariant>
      <Box className="vehicles-grid-container">
        <Typography variant="h2" className="promiseHeader">
          {brandVariantData?.headerInfo}
        </Typography>

        <Typography variant="p" className="content-text">
          {brandVariantData?.description}
        </Typography>

        <Grid container>
          {brandVariantData?.variantList?.map((item, index) => {
            return (
              <Grid key={index} item xs={12}>
                <Box className="Vehicle-container">
                  <LazyLoadImage
                    visibleByDefault={true}
                    src={item?.image}
                    style={{ width : "254px", height: "182px",  objectFit: "contain", margin: "10px auto 0px auto" }}
                    alt={item?.model}
                  />
                  <Box className="price-list">
                    <Typography className="sub-text" variant="h3">
                      {item?.model}
                    </Typography>
                    <Typography>{item?.description}</Typography>
                  </Box>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </CustomerBrandVehicleVariant>
  );
};

const MemoizedBrandVehicleVariant = React.memo(BrandVehicleVariant);
export default MemoizedBrandVehicleVariant;
